import api from '../lib/api'

const base = (tenantId) => `/admin/tenants/${encodeURIComponent(tenantId)}/bot-config`
const noCache = { headers: { 'Cache-Control': 'no-cache' } }

export const getBotConfig = (tenantId) =>
  api.get(base(tenantId), noCache).then((response) => response.data)

export const listPlaybookTemplates = () =>
  api.get('/admin/bot-config/templates', { params: { kind: 'playbook' }, ...noCache })
    .then((response) => response.data ?? { templates: [], available_actions: [] })

export const listPlaybookPlaceholders = (type) =>
  api.get('/admin/bot-config/placeholders', { params: { type }, ...noCache })
    .then((response) => response.data ?? { type, placeholders: [] })

export const saveBotDraft = (tenantId, content, expectedDraftVersion = 0, playbooks) => {
  const body = { content, expected_draft_version: expectedDraftVersion }
  if (playbooks !== undefined) body.playbooks = playbooks
  return api.put(`${base(tenantId)}/draft`, body).then((response) => response.data)
}

export const publishBotConfig = (tenantId, expectedVersion = 0, expectedDraftVersion = 0, confirmGatesChange = false) => {
  const body = {
    expected_version: expectedVersion,
    expected_draft_version: expectedDraftVersion,
    confirm_gates_change: Boolean(confirmGatesChange),
  }
  return api.post(`${base(tenantId)}/publish`, body).then((response) => response.data)
}

export const rollbackBotConfig = (tenantId, expectedVersion = 0, confirmGatesChange = false) => {
  const body = { expected_version: expectedVersion, confirm_gates_change: Boolean(confirmGatesChange) }
  return api.post(`${base(tenantId)}/rollback`, body).then((response) => response.data)
}

export function botConfigErrorDetail(error) {
  const detail = error?.response?.data?.detail
  return detail && typeof detail === 'object' ? detail : {}
}

export function botConfigErrorCode(error) {
  const detail = botConfigErrorDetail(error)
  if (typeof detail.error === 'string') return detail.error
  if (error?.response?.status === 403) return 'permission_denied'
  if (error?.response?.status === 409) return 'draft_conflict'
  if (error?.response?.status === 422) return 'validation_error'
  if (error?.response?.status === 429) return 'rate_limited'
  if (error?.response?.status === 503) return 'authz_lookup_failed'
  return error?.response ? 'unknown' : 'network'
}

export const RETRYABLE_BOT_CONFIG_ERRORS = new Set([
  'authz_lookup_failed', 'tenant_lookup_failed', 'network', 'unknown', 'rate_limited',
])
